export default {
  agreeTitle:
    'Agreement On The Marketing Services Through The “acbuy Affiliate” On acbuy Website',
  agreementText: `Welcome to register on acbuy website and use its marketing services of “acbuy Affiliate”. This Agreement is entered in by and between the partners of “acbuy Affiliate” (hereinafter referred to as “Party B”) and acbuy (hereinafter referred to as “Party A”) (including but not limited to www.acbuy.com, cell phone APP of acbuy and etc., hereinafter referred to as “Party A's Website”) regarding the issues related to the marketing services of “acbuy Affiliate”. Party B shall read carefully all the texts hereof, especially the parts in bold, before using the marketing services of “acbuy Affiliate” on acbuy website, and by clicking the “I have read it and I agree” button, Party B is deemed to have accepted and agreed to comply with the specifications hereof. The Agreement shall constitute the agreement between Party B and acbuy and have legal force. acbuy shall have the right to amend the articles hereof unilaterally based on its business needs, and acbuy shall post such amendments on the Party A's Website immediately in case of any amendments made to the articles hereof, and Party B shall immediately stop using the marketing services on the channel of “acbuy Affiliate” in case Party B disagrees to the amendments to the texts hereof, or otherwise, Party B shall be deemed to agree to the amendments to the texts hereof.
Article 1 Definitions 1. Consumer: means acbuy member who accesses to Party A's Website for registration `,
  dashboard: 'Dashboard',
  hi: 'Hi, ',
  inviteFriends: 'Invite Friends',
  inviteFriendsTips:
    'Invite friends to acbuy, earn more cash! Invite more, earn more, no limit.',
  inviteFriendsTips1:
    'Invite 3 active accounts to obtain sales rights and earn commissions.',
  totalInvite: 'Total Invited Users',
  myTeam: 'My Team',
  extractMoney: 'Commission Settled',
  noExtractMoney: 'Unsettled Commission',
  inviteTitle: 'Invite My Friends',
  copyCode: 'Copy Invitation Code',
  poster: 'Exclusive Poster',
  myLevel: 'My Prerogative ',
  youLevel: 'Your Current Level',
  commissionRate: 'Commission Rate',
  experienceValue: 'Experience Value({num}/{total})',
  levelDesc: 'Level Description',
  invite: 'Invite',
  revenueDetails: 'Invitation Details',
  registerTime: 'Register Time',
  inviteType: 'Related relationships',
  userMail: 'Username Mail',
  bonus: 'Bonus',
  myBonus: 'My Bonus',
  myBalance: 'My balance',
  applyWithdraw: 'Apply For Withdrawal',
  withdrawTips:
    'Tip: Due to the transaction fee involved in withdrawal, it is recommended to Withdrawal an amount higher than ¥500.00 ',
  bank: 'Bank',
  paypalAccount: 'PayPal Account',
  bankAccount: 'Bank Account',
  bankName: 'Bank Name',
  withdrawAmount: 'Withdrawal Amount({unit})',
  bonusDetail: 'Bonus Detail',
  directCommission: 'Direct Commission Details',
  indirectCommission: 'Indirect Commission Details',
  tradeTime: 'Transaction Time',
  packNo: 'Package Number',
  actCommission: 'Commission',
  settlementTime: 'Settlement Time',
  levelName: 'Ambassador Level',
  packStatus: 'Package Status',
  directExplain: 'Commission Rate',
  indirectExplain: `Commission On Secondary Invitees's Shipping Fees`,
  experienceExplain: 'Experience Value',
  withdrawRecord: 'Withdrawal Record',
  withdrawTime: 'Withdrawal Time',
  serialNo: 'Serial No.',
  withdrawStatus: 'Withdrawal Status',
  team: 'Team',
  levelUp: 'Level Up',
  teamInfo: 'Team Information',
  teamNum: 'Number of team users',
  monthCommission: 'Estimated commission for this month',
  accCommission: 'Accumulated settlement commission',
  teamMember: 'Team Member',
  promotedMember: 'Promoted Member',
  invitationTime: 'Invitation Time',
  inviter: 'Inviter',
  promotionTime: 'Promotion Time',
  IBAN: 'IBAN',
  swiftCode: 'Swift code',
  bankAddress: 'Bank address',
  setting: 'Setting',
  profile: 'Profile',
  withdrawMethod: 'Withdrawal Method',
  myPrerogative: 'My Prerogative',
  verifyEmail: 'Verify Your Email',
  sendCodeTips:
    'We sent a verify code to <strong>{email}</strong>. Enter the code below to verify.',
  noGetEmail: `Didn't get your email?`,
  codeErrorTips: 'Code error, please try again',
  resendTime: 'Resend the code ({time}s)',
  or: 'or',
  contactService: 'Contact online customer service',
  addMethod: 'New Withdrawal Method',
  editMethod: 'Edit Withdrawal Method',
  rePaypalAccount: 'Re-Enter PayPal Account',
  directInvite: 'Direct Invitation',
  indirectInvite: 'Indirect Invitation',
  noSameAccount: 'The account is different from the confirmed account',
  noAddWithdrawMethod: `You haven't added a Withdrawal method`,
  statusEnum: {
    0: 'To be issued',
    1: 'Under release',
    2: 'Release success',
    3: 'Provisioning failure',
    4: 'Withdrawal of withdrawal'
  },
  userDetail: 'User Detail',
  balance: 'Account balance',
  withdrawMax: 'Amount more than ¥500.00',
  addPaypalAccount: 'Add Paypal Account',
  addBankAccount: 'Add Bank Account',
  noPaypalAccount: 'No Paypal Account',
  noBankAccount: 'No Bank Account',
  estimated: 'Signed for',
  notEstimated: 'Not Signed for',
  actual: 'Actual',
  estiamte: 'Estiamte',
  directRealtion: 'Direct relationship',
  indirectRealtion: 'Indirect relationship',
  experienceValueText: 'Experience Value',
  relatedParcel: 'Related Parcel',
  empiricalValue: 'Empirical Value',
  acquiringTime: 'Acquiring Time',
  relatedEmail: 'Related Email',
  relatedUsers: 'Related Users',
  balanceDetail: 'Balance Detail',
  commissionDetail: 'Commission Detail',
  details: 'Details',
  question1:
    'After the invited user completes the bag, their status will be updated to "Activated"',
  question2:
    'The order has been completed and the commission has been transferred to your balance account',
  question3:
    'Commission for all "unconfirmed receipt" orders. The order will be verified within 30-60 days, and then the commission will be transferred to your balance account',
  activatedUser: 'Activated User',
  bankTip: 'Withdrawal handling fee: 2% of the withdrawal amount',
  selectWithdrawMethod: 'Select  withdrawal account',
  currentWithdrawAmount: 'Current withdrawable amount',
  modify: 'Modify',
  bonusBalance: 'Bonus available balance',
  balanceTips1:
    '1.Payment of settlement commission for the previous month on the 1st(UTC+8) of each month',
  balanceTips2:
    '2.The 1st(UTC+8) to 10th(UTC+8) of each month is the withdrawal date, and you can choose to withdraw from the 1st(UTC+8) to the 10th(UTC+8). We will transfer the funds to you before the 20th(UTC+8), and after the transfer, we will notify you of the transfer result by email. At the same time, you can check the transfer related information in the withdrawal record.',
  income: 'Income',
  expenditure: 'Expenditure',
  commissionSettlement: 'Commission Settlement',
  commissionWithdrawal: 'Commission Withdrawal',
  withdrawalCancellation: 'Withdrawal cancellation',
  activeStatus: 'Active Status',
  settlePackageNum: 'Package Quantity',
  activeTime: 'Active Time',
  orderTime: 'Submit package time',
  orderUser: 'Order User',
  actualFreight: 'Actual freight payment',
  estimatedCommission: 'Estimated commission',
  withdrawAccount: 'Withdrawal Account',
  withdrawType: 'Withdrawal type',
  withdrawTypeEnum: {
    2: 'Withdraw to balance',
    0: 'Withdraw to bank'
  },
  applyTime: 'Application Date',
  withdrawStatusEnum: {
    0: 'Under review',
    1: 'Withdrawing',
    2: 'Withdraw success',
    3: 'Withdraw refuse',
    4: 'Withdraw cancel'
  },
  bankEndNumber: 'Bank card ending number',
  cancelWithdraw: 'Cancel Withdraw',
  withdrawalDetails: 'Withdrawal Details',
  transferVoucher: 'transfer voucher',
  cancelWithdrawConfirm: 'Cancel Withdrawal Confirmation',
  delPackageHint:
    'After confirming the cancellation of the withdrawal, the corresponding withdrawal amount will be returned to your commission balance',
  withdrawTip:
    'The 1st(UTC+8) - 10th(UTC+8) of each month are withdrawal days,and you can choose to withdraw from the 1st(UTC+8) to the 10th(UTC+8)',
  hasLogOff: 'Log off'
};
